import Medal from "./game/Medal";

export class SaveData {
	firstTimeUser = true;
	seenTutorial = false;
	dayTrainingComplete = false;
	nightTrainingComplete = false;
	certificationEarned = false;

	currentLevel = 0;
	levelToLoad = 0;

	lastLevelMedal: number | null;

	medalsEarned: string[] = [Medal.None, Medal.None, Medal.None, Medal.None, Medal.None, Medal.None, Medal.None, Medal.None];

	constructor() {
		this.currentLevel = 0;
		this.levelToLoad = 0;
		this.firstTimeUser = true;
		this.seenTutorial = false;
		this.medalsEarned = [Medal.None, Medal.None, Medal.None, Medal.None, Medal.None, Medal.None, Medal.None, Medal.None];
		this.dayTrainingComplete = false;
		this.nightTrainingComplete = false;
		this.certificationEarned = false;
	}
}
